
interface action {
    type: string,
    payload: Array<any>,
}

const yearReceiptsDailyReducer = (state = [], action: action) => {
    switch(action.type) {
        case 'SET_YEAR_RECEIPTS_DAILY':
            return action.payload;
        default:
            return state;
    }
}

export default yearReceiptsDailyReducer;